import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/key/main.png';
import _imports_1 from '@/assets/imgs/key/qa.png';
import _imports_2 from '@/assets/imgs/key/down.png';
import _imports_3 from '@/assets/imgs/key/right.png';
import _imports_4 from '@/assets/imgs/key/use.png';
const _withScopeId = n => (_pushScopeId("data-v-58018160"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "wrap wrap-top"
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_0
})], -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "wrap wrap-why"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "qa"
};
const _hoisted_9 = {
  class: "main"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "icon"
};
const _hoisted_13 = {
  key: 0,
  class: "down",
  src: _imports_2,
  alt: ""
};
const _hoisted_14 = {
  key: 1,
  class: "right",
  src: _imports_3,
  alt: ""
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "wrap use"
};
const _hoisted_17 = {
  class: "main"
};
const _hoisted_18 = {
  class: "left"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_4
})], -1));
import { onMounted, ref } from 'vue';
import Download from '@/components/Download.vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'Key',
  setup(__props) {
    const {
      t
    } = useI18n();
    const qa = ref([]);
    const clickShow = (isShow, i) => {
      qa.value[i] = !isShow;
    };
    onMounted(() => {
      document.documentElement.scrollTop = 0;
      qa.value = new Array(5).fill(false);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('key.top.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('key.top.desc')), 1), _createVNode(Download)])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('key.feature.title')), 1), _createElementVNode("ul", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, i => {
        return _createElementVNode("li", null, [_createElementVNode("img", {
          src: require(`@/assets/imgs/key/${i - 1}.png`),
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("h3", null, _toDisplayString(_unref(t)(`key.feature.list[${i - 1}].title`)), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)(`key.feature.list[${i - 1}].desc`)), 1)]);
      }), 64))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('key.qa.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('key.qa.desc')), 1), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.value, (isShow, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(isShow && 'show')
        }, [_createElementVNode("div", {
          class: "q",
          onClick: $event => clickShow(isShow, i)
        }, [_createElementVNode("div", _hoisted_12, [isShow ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : (_openBlock(), _createElementBlock("img", _hoisted_14))]), _createElementVNode("h4", null, _toDisplayString(_unref(t)(`key.qa.list[${i}].q`)), 1)], 8, _hoisted_11), isShow ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)(`key.qa.list[${i}].a`)), 1)) : _createCommentVNode("", true)], 2);
      }), 256))])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("h1", null, _toDisplayString(_unref(t)('key.use.title')), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)('key.use.desc')), 1), _createVNode(Download)]), _hoisted_19])])]);
    };
  }
});